import { useEffect, useState } from "react";
import { DefaultEditor } from "react-simple-wysiwyg";
import AdminSidebar from "./components/AdminSidebar";
import AdminHeader from "./components/AdminHeader";
import Loader from "../components/Loader";
import axios from "axios";
// import { useNavigate } from "react-router-dom";
import openNotification from "../components/OpenNotification";

const EmailTemplatesManager = () => {
  // const navigate = useNavigate();

  const [templates, setTemplates] = useState([]);
  const [form, setForm] = useState({
    id: null,
    title: "",
    content: "",
    description: "",
  });
  const [isLoading, setIsLoading] = useState(true);

  // ✅ Fetch templates on load
  useEffect(() => {
    document.title = "Barterfunds | Email Templates";

    fetchTemplates();
  }, []);

  const formatDate = (dateTimeString) => {
    const date = new Date(dateTimeString);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };

  const fetchTemplates = () => {
    const token = window.sessionStorage.getItem("token");
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/email-templates`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        if (res.data.success) {
          setTemplates(res.data.templates);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching templates", err);
        setIsLoading(false);
      });
  };

  // ✅ Handle input changes
  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  // ✅ Handle editor content
  const handleEditorChange = (e) => {
    setForm((prev) => ({
      ...prev,
      content: e.target.value,
    }));
  };

  // ✅ Save or Update template
  const handleSave = (e) => {
    e.preventDefault();
    if (!form.title || !form.content)
      return openNotification(
        "topRight",
        "error",
        "Error",
        "Title and content are required."
      );

    setIsLoading(true);

    const token = window.sessionStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    // Update existing
    if (form.id) {
      axios
        .patch(
          `${process.env.REACT_APP_API_URL}/email-templates/${form.id}`,
          {
            title: form.title,
            description: form.description,
            content: form.content,
          },
          { headers }
        )
        .then((res) => {
          if (res.data.success) {
            openNotification(
              "topRight",
              "success",
              "Email template update successful",
              "Email template has been successfully updated."
            );
            fetchTemplates();
            setForm({ id: null, title: "", description: "", content: "" });
          }
        })
        .catch((err) => {
          console.error("Error updating template", err);

          openNotification(
            "topRight",
            "error",
            "Error",
            "Error updating template"
          );
        });
    } else {
      // Add new
      axios
        .post(
          `${process.env.REACT_APP_API_URL}/email-templates`,
          {
            title: form.title,
            description: form.description,
            content: form.content,
          },
          { headers }
        )
        .then((res) => {
          if (res.data.success) {
            openNotification(
              "topRight",
              "success",
              "Email template update successful",
              "Email template has been successfully updated."
            );
            fetchTemplates();
            setForm({ id: null, title: "", description: "", content: "" });
          }
        })
        .catch((err) => {
          console.error("Error creating template", err);
          openNotification(
            "topRight",
            "error",
            "Error",
            "Error creating template"
          );
        });
    }

    setIsLoading(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ✅ Edit template
  const handleEdit = (template) => {
    setForm({
      id: template._id,
      title: template.title,
      description: template.description || "",
      content: template.content,
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ✅ Delete template with confirmation
  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this template?")) {
      const token = window.sessionStorage.getItem("token");
      axios
        .delete(`${process.env.REACT_APP_API_URL}/email-templates/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          if (res.data.success) {
            openNotification(
              "topRight",
              "success",
              "Email template delete successful",
              "Email template has been successfully deleted."
            );
            fetchTemplates();
          }
        })
        .catch((err) => {
          console.error("Error deleting template", err);
          openNotification(
            "topRight",
            "error",
            "Error",
            "Error deleting template"
          );
        });
    }
  };

  // const handleBack = () => {
  //   navigate(-1);
  // };

  return (
    <div className="page-wrapper default-version">
      <AdminSidebar active={"mailer"} />
      <AdminHeader />

      {isLoading ? (
        <Loader />
      ) : (
        <div className="body-wrapper">
          <div className="bodywrapper__inner">
            <div className="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
              <h6 className="page-title">
                {form.id ? "Edit Email Template" : "Create Email Template"}
              </h6>
              <div className="d-flex flex-wrap justify-content-end gap-2 align-items-center breadcrumb-plugins">
                {/* <button
                  onClick={handleBack}
                  className="btn btn-sm btn-outline--primary"
                >
                  <i className="la la-undo" /> Back
                </button> */}
              </div>
            </div>

            <div className="card gy-4 px-3">
              {/* Title Input */}
              <div className="form-group mt-3">
                <label>Title</label>
                <input
                  type="text"
                  name="title"
                  className="form-control"
                  value={form.title}
                  onChange={handleChange}
                  placeholder="Enter template title"
                />
              </div>

              <div className="form-group mt-3">
                <label>Description(optional)</label>
                <input
                  type="text"
                  name="description"
                  className="form-control"
                  value={form.description}
                  onChange={handleChange}
                  placeholder="Enter a brief description of the template"
                />
              </div>

              {/* Content Editor */}
              <div className="form-group mt-3">
                <label>Content</label>
                <DefaultEditor
                  name="content"
                  value={form.content}
                  onChange={handleEditorChange}
                  rows={8}
                />
              </div>

              <div className="col-12">
                <button
                  type="submit"
                  className="btn btn--primary w-100 h-45 center"
                  onClick={handleSave}
                >
                  {form.id ? "Update Template" : "Save Template"}
                </button>
              </div>

              <hr className="my-4" />
              <h5>Saved Templates</h5>
{templates.length > 0 ? (
  <div className="table-wrapper mt-3">
    <div className="custom-table">
      {/* Table Header */}
      <div className="custom-table-row custom-table-header">
        <div className="col-title">Title</div>
        <div className="col-description">Description</div>
        <div className="col-content">Content Preview</div>
        <div className="col-created">Created On</div>
        <div className="col-actions">Actions</div>
      </div>

      {/* Table Rows */}
      {templates.map((tpl) => (
        <div className="custom-table-row" key={tpl._id}>
          <div className="col-title">{tpl.title}</div>
          <div className="col-description">
            {tpl.description || "No description"}
          </div>
          <div
            className="col-content"
            dangerouslySetInnerHTML={{ __html: tpl.content }}
          />
          <div className="col-created">{formatDate(tpl.createdAt)}</div>
          <div className="col-actions">
            <button
              className="btn btn-sm btn-warning me-2"
              onClick={() => handleEdit(tpl)}
            >
              Edit
            </button>
            <button
              className="btn btn-sm btn-danger"
              onClick={() => handleDelete(tpl._id)}
            >
              Delete
            </button>
          </div>
        </div>
      ))}
    </div>
  </div>
) : (
  <p>No templates saved yet.</p>
)}

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmailTemplatesManager;
